import React from 'react'
import Link from 'next/link'
import {useTranslation} from '@lib/intl/useTranslations'
import {useRouter} from 'next/router'

import {URL_ACCOUNT_POINT} from '@constant/url'
import {createLog} from '@util/logs'
import {IGlobalNavigationStyles} from '@component/header/GlobalNavigation/GlobalNavigation'

import {DarkModeStore} from '@store/DarkmodeStore'
import useQueryFetchMe from '@hook/query/account/useQueryFetchMe'
import useFormatNumber from '@hook/useFormatNumber'
import {useImportantAlertsContext} from '@hook/useImportantAlerts'

import Text from '@component/Text/Text'
import UserThumbnail from '@component/images/UserThumbnail'

import useQueryGetPoint from '@hook/query/account/point/useQueryGetPoint'
import useQueryGetNotificationCount from '@hook/query/account/notification/useQueryGetNotificationCount'
import NavigationAccountOperationMenu from '@component/header/GlobalNavigation/NavigationOperations/NavigationAccountOperationMenu'

import IconLeaguePoint from '@svg/common/ic_league_point_symbol.svg'
import IconWhiteLeaguePoint from '@svg/common/ic_league_point_symbol_white.svg'
import IconNoticeRed from '@svg/common/ic_notice_red.svg'

interface IProps {
    className?: string
    navStyles?: IGlobalNavigationStyles
    onClickMobileAccountNavigation?: () => void
}

const NavigationAccountOperation: React.FC<IProps> = ({className, navStyles, onClickMobileAccountNavigation}) => {
    const t = useTranslation()
    const router = useRouter()
    const currentPath = router?.asPath
    const {displayNumber} = useFormatNumber()
    const {isCheckDark, isDark} = DarkModeStore()
    const {alertLength, invoiceAlertLength, proAlertLength, settingAlertLength} = useImportantAlertsContext()

    const {data: me} = useQueryFetchMe(undefined, false)
    const {data: point, isLoading} = useQueryGetPoint()
    const {data: notificationCount} = useQueryGetNotificationCount(false)

    return (
        <div className={`flex items-center gap-x-[10px] md:flex-none md:overflow-visible ${className}`}>
            {/* User Point */}
            {!isLoading && (
                <Link
                    href={`/${router?.locale}${URL_ACCOUNT_POINT}`}
                    onClick={e => {
                        if (`${URL_ACCOUNT_POINT}` === currentPath && e?.cancelable) {
                            e?.preventDefault()
                        } else {
                            createLog('event', 'gnb_league_point_click')
                        }
                    }}>
                    <div className={'flex items-center gap-x-[5px]'}>
                        {navStyles?.logoType === 'white' || (isCheckDark && isDark) ? (
                            <IconWhiteLeaguePoint className={'w-[20px] md:w-[22px]'} />
                        ) : (
                            <IconLeaguePoint className={'w-[20px] md:w-[22px] fill-black'} />
                        )}

                        <Text className={`text-btn_sm text-[15px] ${navStyles?.TextPrimaryColor}`}>
                            {t('point.text', {point: displayNumber(point?.current_point || 0)})}
                        </Text>
                    </div>
                </Link>
            )}

            {/* User Account Info */}
            <NavigationAccountOperationMenu className={'md:hidden'} />

            {/* User Account Info + Notification */}
            <div className={'hidden md:block cursor-pointer md:mr-[25px]'} onClick={onClickMobileAccountNavigation}>
                <div className={'relative h-[24px]'}>
                    <UserThumbnail src={me?.thumbnail} size={24} isPro={me?.is_pro} />
                    {alertLength + invoiceAlertLength + proAlertLength + settingAlertLength > 0 ? (
                        <>
                            <IconNoticeRed
                                className={
                                    'w-[14px] h-[14px] fill-red_shade dark:fill-dark_red_shade absolute bottom-0 md:bottom-[-4px] left-[15px]'
                                }
                            />
                        </>
                    ) : null}
                    {notificationCount > 0 ? (
                        <div
                            className={
                                'absolute bg-red_shade dark:bg-dark_red_shade w-[5px] h-[5px] rounded-full top-[-2px] right-[-3px]'
                            }
                        />
                    ) : (
                        <></>
                    )}
                </div>
            </div>
        </div>
    )
}
export default NavigationAccountOperation
